module.exports = __webpack_public_path__ + "static/img/shuiyinyuan333.06ea013.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shuiBrand/shuiyinyuan333.png
// module id = EuiI
// module chunks = 0